import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExportConfigurationModal } from './ExportCategoriesModal';
import styles from './CategoriesExport.module.less';

type CategoriesExportProps = {
  vertical: string | null;
  sourceOwnerId: string | null;
};

export const CategoriesExport: React.FC<CategoriesExportProps> = ({ vertical, sourceOwnerId }) => {
  const [exportModalVisible, setExportModalVisible] = useState<boolean>(false);
  const isExportEnabled = !!(vertical && sourceOwnerId);
  const showExportModal = () => {
    if (isExportEnabled) {
      setExportModalVisible(true);
    }
  };
  const hideExportModal = () => setExportModalVisible(false);

  return (
    <div className={styles.downLoadIcon}>
      <a className={isExportEnabled ? styles.enabled : styles.disabled} onClick={showExportModal}>
        <FontAwesomeIcon icon={['fal', 'download']} />
      </a>

      {isExportEnabled && (
        <ExportConfigurationModal
          className={styles.exportModal}
          visible={exportModalVisible}
          vertical={vertical!}
          sourceOwnerId={sourceOwnerId!}
          closeModal={hideExportModal}
        />
      )}
    </div>
  );
};
